import React from 'react'
import ContactSection from './ContactSection'

const Contact: React.FC = () => <ContactSection />

export default Contact
